var React = require('react');

function IconTwitterInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M397.2,196.7c0.3,3.9,0.3,7.8,0.3,11.7c0,118.7-90.4,255.5-255.5,255.5C91,463.9,43.8,449.2,4,423.6\n\tc7.2,0.8,14.2,1.1,21.7,1.1c42,0,80.6-14.2,111.5-38.4c-39.5-0.8-72.6-26.7-84-62.3c5.6,0.8,11.1,1.4,17,1.4\n\tc8.1,0,16.1-1.1,23.6-3.1c-41.2-8.3-72-44.5-72-88.1v-1.1c12,6.7,25.9,10.8,40.6,11.4c-24.2-16.1-40-43.7-40-74.8\n\tc0-16.7,4.4-32,12.2-45.3c44.2,54.5,110.7,90.1,185.2,94c-1.4-6.7-2.2-13.6-2.2-20.6c0-49.5,40-89.8,89.8-89.8\n\tc25.9,0,49.2,10.8,65.6,28.4c20.3-3.9,39.8-11.4,57-21.7c-6.7,20.9-20.9,38.4-39.5,49.5c18.1-1.9,35.6-7,51.7-13.9\n\tC430,168.1,414.7,183.9,397.2,196.7L397.2,196.7z"}));
}

IconTwitterInline.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 448 512","style":{"enableBackground":"new 0 0 448 512"},"xmlSpace":"preserve"};

module.exports = IconTwitterInline;

IconTwitterInline.default = IconTwitterInline;
